import { defineComponent as _, ref as C, openBlock as g, createBlock as m, unref as f, withKeys as Pa, withModifiers as Zn, createElementBlock as B, createVNode as D, withCtx as O, createCommentVNode as x, Fragment as Xn, createTextVNode as Ra, toDisplayString as Oa, renderSlot as j, computed as k, onMounted as $t, normalizeClass as Yn, watch as Aa, onBeforeMount as Ia, createElementVNode as J, mergeProps as ja, createApp as ka } from "vue";
import { BaseSearchBox as ea, TeaserBoxesSlider as xa, AnnouncementItem as Ba, CtaElementType as Va, BaseLink as Ma, BaseIconType as La, ResponsivePicture as Da, HTMLContentBlock as Na, ProductBuyingProcessModal as Fa, BaseHeading as Ua, useTranslation as Ea, EntryGateModal as Ga, AspectRatio as Ha, BaseImage as Yt, ColumnLayoutType as U, StretchedColumn as ta, PageSection as zt, TwoColumnLayout as ra, ThreeColumnLayout as $a, useCallLeavingDisclaimer as er, LeavingDisclaimer as za, RiskDisclaimer as Ka, ContentBoxWithImage as Wa, ContentBox as Ja, ArticlePageOverview as Qa, ContentSlider as Za, QuizAndPoll as na, useArchivePageStore as Xa, ArchivePageSearchEventType as Ya, ArchivePage as eo, Calendar as to, FaqPage as ro, useSearchResultPageStore as no, SearchResultsEventType as ao, SearchResultPage as oo, usePropertyGalleryStore as so, PropertyGalleryPageContainer as io, PropertyDetailPage as uo, Glossary as lo, useMediaReleasesStore as co, MediaReleasesSearchEventType as tr, MediaReleasesContainer as fo, ProductBuyingProcess as po, BaseInputState as Q, AlignContent as rr, HeaderArea as go, Heading as ho, BaseInput as mo, BaseInputLabelPosition as vo, BaseInputType as yo, BaseButton as _o, ButtonType as bo, BaseButtonType as wo, LinkType as To, Footer as Co, PageFrame as qo, Header as So, TeaserWww as Po, TeaserHero as Ro, TeaserEvents as Oo, TeaserBoxes as Ao, KeyFacts as Io, ProductTeaserTopProducts as jo, TeaserMostClickedFunds as ko, ProductTeaserFundsInFocus as xo, PersonSectionBlock as Bo, PersonDetailPage as Vo, TabContainer as Mo, TabContent as Lo, VideoModule as Do, DownloadList as No, TopicTileContentBlock as Fo, Quote as Uo, AccordionContainer as Eo, AccordionItem as Go, ExpandableTeasers as Ho, EvervizChart as $o, NewsletterTeaser as zo, PageFootnoteList as Ko, PageFootnoteReference as Wo, BaseDisclaimer as nr, TimelineBlock as Jo, ProductChartTeaser as Qo, ProductChartTeasers as Zo, DataTable as Xo, SingleVideoModule as Yo, ErrorPage as es, FeaturedPropertyTeaser as ts, FactsLists as rs, MarketDataBlock as ns, ImageGallery as as, JumpmarkAnchor as os, ArticleHeader as ss, ImageGalleryTeaser as is, ProductTeaserWithImage as us, BaseContactBox as ls, MediaReleasesDetailsPage as cs, GlossaryItem as ds, EntryDisclaimer as fs, AudioModule as ps, ArticlePageLayout as gs, InvestmentCalculator as hs, InflationCalculator as ms, FormBuilder as vs, BaseIframe as ys, Breadcrumb as _s, DxPlugin as bs } from "dws-dx";
const ws = /* @__PURE__ */ _({
  __name: "fund-search",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = C(t.model), n = C(t.model.resultModel);
    let o;
    const s = () => {
      if (o && (o.abort(), o = void 0), !r.value.searchTerm || r.value.searchTerm.length < 3)
        return;
      o = new AbortController();
      const l = {
        filterOptions: r.value.filterOptions,
        searchTerm: r.value.searchTerm,
        culture: r.value.culture,
        blockId: r.value.blockId
      };
      fetch(r.value.fundSearchApi, {
        body: JSON.stringify(l),
        signal: o.signal,
        headers: new Headers({
          "Content-Type": "application/json"
        }),
        method: "POST"
      }).then((c) => {
        if (c.ok)
          return c.json();
        throw new Error("Request returned an error");
      }).then((c) => {
        n.value.allResultsLink = c.allResultsLink, n.value.results = c.results;
      });
    }, a = (l) => {
      !l || l.length < 3 || (r.value.searchTerm = l, s());
    }, i = () => {
    }, u = (l) => {
      if (!r.value.filterOptions)
        return;
      const c = l?.isSelected;
      r.value.filterOptions.forEach((d) => d.isSelected = !1), c && (l.isSelected = !0), r.value.filterOptions = [...r.value.filterOptions], s();
    };
    return (l, c) => (g(), m(f(ea), {
      model: r.value,
      "min-length": 3,
      result: n.value,
      onSearch: a,
      onFilterChanged: u,
      onKeydown: Pa(Zn(i, ["prevent"]), ["enter"]),
      "page-name": e.model.pageName
    }, null, 8, ["model", "result", "onKeydown", "page-name"]));
  }
}), Ts = { class: "d-announcements" }, Cs = {
  key: 0,
  class: "d-announcements__button-right"
}, qs = /* @__PURE__ */ _({
  __name: "teaser-announcements",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (g(), B("div", Ts, [
      D(f(xa), {
        model: e.model.teasers,
        "link-corner": !0
      }, {
        teaserContent: O((n) => [
          D(f(Ba), {
            "teaser-content": n.teaserContent
          }, null, 8, ["teaser-content"])
        ]),
        _: 1
      }, 8, ["model"]),
      e.model.ctaElementType && e.model.readMoreLink ? (g(), B("div", Cs, [
        e.model.ctaElementType === f(Va).Link ? (g(), m(f(Ma), {
          key: 0,
          "link-model": e.model.readMoreLink,
          icon: f(La).ArrowRight
        }, null, 8, ["link-model", "icon"])) : x("", !0)
      ])) : x("", !0)
    ]));
  }
}), Ss = /* @__PURE__ */ _({
  __name: "image-block",
  props: {
    model: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    return (t, r) => (g(), m(f(Da), {
      model: e.model,
      "aspect-ratio": e.model.picture.aspectRatio
    }, null, 8, ["model", "aspect-ratio"]));
  }
}), Ps = /* @__PURE__ */ _({
  __name: "html",
  props: {
    html: {
      type: String,
      required: !0
    },
    productBuyingProcessPageProps: {
      type: Object,
      required: !1
    },
    allPartners: {
      type: Array,
      required: !1
    },
    pageName: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = C(t.productBuyingProcessPageProps), n = C(!1);
    function o(s) {
      if (!r.value || !t.allPartners) return;
      const a = s.target, i = a.closest("button");
      if (!i)
        return;
      if (i.hasAttribute("data-isin")) {
        const l = a.getAttribute("data-isin") ?? "";
        r.value.partnerInformation = t.allPartners.filter((c) => c.productIdentifiers.some((d) => d.toLowerCase() === l.toLowerCase())).map((c) => ({
          ...c,
          link: c.link ? {
            ...c.link,
            href: c.link.href?.toLowerCase().replace("{isin}", l) ?? c.link.href
          } : c.link
        }));
      }
      n.value = !0;
    }
    return (s, a) => (g(), B(Xn, null, [
      D(f(Na), {
        htmlText: t.html,
        onClick: o
      }, null, 8, ["htmlText"]),
      r.value ? (g(), m(f(Fa), {
        key: 0,
        model: r.value,
        openDialog: n.value,
        "partners-alphabetically-sorted": !0,
        onClose: a[0] || (a[0] = (i) => n.value = !1),
        "page-name": t.pageName
      }, null, 8, ["model", "openDialog", "page-name"])) : x("", !0)
    ], 64));
  }
}), Rs = /* @__PURE__ */ _({
  __name: "header",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (r, n) => (g(), m(f(Ua), {
      baseHeadingType: t.model.baseHeadingType
    }, {
      default: O(() => [
        Ra(Oa(t.model.header), 1)
      ]),
      _: 1
    }, 8, ["baseHeadingType"]));
  }
}), ar = "other-country", Os = /* @__PURE__ */ _({
  __name: "entry-gate-modal",
  props: {
    entryGate: {
      type: Object,
      required: !0
    },
    header: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { setLocale: t } = Ea(), r = e;
    let n;
    const o = C(r.entryGate), s = C(document.referrer), a = async (i) => {
      const { location: u } = window, { href: l } = u, c = document.querySelector('meta[name="culture"]'), { content: d } = c, { value: p } = i;
      if (p !== ar) {
        t(p), n?.abort(), n = new AbortController();
        const h = new URLSearchParams({
          url: l,
          pageCulture: d,
          displayCulture: p,
          referrer: s.value,
          pageId: r.entryGate.pageId
        }).toString(), v = await fetch(`/EntryGate/GetEntryGateInCulture?${h.toString()}`, {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          signal: n.signal
        });
        if (v.ok) {
          const w = await v.json();
          w.audienceList?.forEach((q) => q.isSelected = !1), o.value = w;
        }
      } else
        o.value?.countryDropdown && o.value.countryDropdown.forEach((h) => {
          h.value === ar ? h.isSelected = !0 : h.isSelected = !1;
        });
    };
    return (i, u) => (g(), m(f(Ga), {
      "entry-gate": o.value,
      onCultureChanged: a,
      header: e.header,
      "page-name": r.entryGate.pageName
    }, null, 8, ["entry-gate", "header", "page-name"]));
  }
}), As = { class: "d-image-wrapper" }, Is = /* @__PURE__ */ _({
  __name: "image",
  props: {
    model: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    return (t, r) => (g(), B("div", As, [
      e.model.aspectRatio && e.model.aspectRatio != f(Ha).None ? (g(), m(f(Yt), {
        key: 0,
        model: e.model,
        "aspect-ratio": e.model.aspectRatio,
        "responsive-options": e.model.responsiveOptions
      }, null, 8, ["model", "aspect-ratio", "responsive-options"])) : (g(), m(f(Yt), {
        key: 1,
        model: e.model,
        "responsive-options": e.model.responsiveOptions
      }, null, 8, ["model", "responsive-options"]))
    ]));
  }
}), js = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, ks = {};
function xs(e, t) {
  return g(), B("div", null, [
    j(e.$slots, "default")
  ]);
}
const Bs = /* @__PURE__ */ js(ks, [["render", xs]]), Vs = /* @__PURE__ */ _({
  __name: "layout-row",
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    elementCount: {
      type: Number,
      required: !0
    },
    rowId: {
      type: String,
      default: "section_0"
    },
    isFirst: {
      type: Boolean,
      default: !1
    },
    nextIsBgGrey: {
      type: Boolean,
      default: !1
    },
    prevIsBgGrey: {
      type: Boolean,
      default: !1
    },
    isLast: {
      type: Boolean,
      default: !1
    },
    prevHasOneItem: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, r = k(() => t.elementCount === 1), n = k(() => {
      switch (t.row.layoutType) {
        case "TwoCol_66_33":
          return U.TwoThirdsOneThird;
        case "TwoCol_33_66":
          return U.OneThirdTwoThirds;
        case "TwoCol_50_50":
          return U.HalfHalf;
        default:
          return U.HalfHalf;
      }
    }), o = k(() => {
      switch (t.row.layoutType) {
        case "TwoCol_50_50":
        case "TwoCol_66_33":
        case "TwoCol_33_66":
        case "TwoCol_75_25":
        case "TwoCol_25_75":
          return 2;
        case "ThreeCol_33_33_33":
          return 3;
        default:
          return 1;
      }
    }), s = k(() => t.row.layoutType.toLowerCase() === "onecol_centered"), a = k(() => t.row.layoutType.toLowerCase() === "onecol_fullwidth"), i = k(() => t.row.stretchedColumn === ta.None);
    return (u, l) => (g(), B(Xn, null, [
      o.value === 1 ? (g(), m(f(zt), {
        key: 0,
        id: e.rowId,
        "content-in-full-width": a.value,
        "one-column-centered": s.value,
        "no-margin": e.row.noMargin,
        background: e.row.backgroundColor,
        title: e.row.sectionHeadline,
        "base-heading-type": e.row.headlineType,
        "is-first": e.isFirst,
        "is-last": e.isLast,
        "next-is-bg-grey": e.nextIsBgGrey,
        "has-one-item": r.value
      }, {
        default: O(() => [
          j(u.$slots, "colone")
        ]),
        _: 3
      }, 8, ["id", "content-in-full-width", "one-column-centered", "no-margin", "background", "title", "base-heading-type", "is-first", "is-last", "next-is-bg-grey", "has-one-item"])) : x("", !0),
      o.value === 2 ? (g(), m(f(ra), {
        key: 1,
        id: e.rowId,
        "layout-type": n.value,
        "no-margin": e.row.noMargin,
        "stretched-column": e.row.stretchedColumn,
        title: e.row.sectionHeadline,
        "base-heading-type": e.row.headlineType,
        "content-width": i.value,
        "vertical-align-content-col-one": e.row.verticalAlignment,
        "vertical-align-content-col-two": e.row.verticalAlignment
      }, {
        colone: O(() => [
          j(u.$slots, "colone")
        ]),
        coltwo: O(() => [
          j(u.$slots, "coltwo")
        ]),
        _: 3
      }, 8, ["id", "layout-type", "no-margin", "stretched-column", "title", "base-heading-type", "content-width", "vertical-align-content-col-one", "vertical-align-content-col-two"])) : x("", !0),
      o.value === 3 ? (g(), m(f($a), {
        key: 2,
        id: e.rowId,
        "no-margin": e.row.noMargin,
        title: e.row.sectionHeadline,
        "base-heading-type": e.row.headlineType,
        "content-width": i.value,
        "stretched-column": e.row.stretchedColumn,
        "vertical-align-content-col-one": e.row.verticalAlignment,
        "vertical-align-content-col-two": e.row.verticalAlignment,
        "vertical-align-content-col-three": e.row.verticalAlignment
      }, {
        colone: O(() => [
          j(u.$slots, "colone")
        ]),
        coltwo: O(() => [
          j(u.$slots, "coltwo")
        ]),
        colthree: O(() => [
          j(u.$slots, "colthree")
        ]),
        _: 3
      }, 8, ["id", "no-margin", "title", "base-heading-type", "content-width", "stretched-column", "vertical-align-content-col-one", "vertical-align-content-col-two", "vertical-align-content-col-three"])) : x("", !0)
    ], 64));
  }
}), oe = "leaving-disclaimer", aa = /* @__PURE__ */ _({
  __name: "leaving-disclaimer",
  props: {
    title: {},
    content: {},
    whitelist: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = k(() => ({
      headerText: t.title,
      disclaimers: [{
        key: oe,
        value: t.content
      }],
      appendTo: "#dx-overlay-leaving-disclaimer"
    })), n = C(!1);
    function o(a) {
      const i = a.target, u = i?.closest("button"), l = u?.getAttribute("data-pc-section"), c = u?.closest("div#dx-overlay-leaving-disclaimer");
      if (l == "closebutton" && c != null) {
        n.value = !1;
        return;
      }
      if ((u?.getAttribute("class") ?? "").indexOf("d-modal-dialog__secondary") > 0 && c != null) {
        n.value = !1;
        return;
      }
      const h = i?.closest("a")?.getAttribute("href");
      if (!(!h || h === "javascript:void(0)")) {
        if (n.value) {
          n.value = !1;
          return;
        }
        s(h) && h && (er(a, h, oe), n.value = !0);
      }
    }
    if (document && (document.removeEventListener("click", o), document.addEventListener("click", o)), window) {
      const a = window.open;
      window.open = function(i, u, l) {
        const c = new CustomEvent("window-open"), d = i?.toString();
        if (n.value)
          return n.value = !1, null;
        if (s(d) && d)
          er(c, d, oe), n.value = !0;
        else
          return a(i, u || "", l || "");
        return null;
      };
    }
    function s(a) {
      if (a) {
        if (!a.startsWith("http"))
          return !1;
        const i = new URL(window.location.origin), u = new URL(a);
        if (i.hostname === u.hostname || t.whitelist && t.whitelist.find((l) => a.indexOf(l.valueOf()) > -1))
          return !1;
      }
      return !0;
    }
    return (a, i) => (g(), m(f(za), {
      model: r.value,
      "page-name": e.pageName
    }, null, 8, ["model", "page-name"]));
  }
}), Ms = /* @__PURE__ */ _({
  __name: "products-teaser-area",
  setup(e) {
    const t = C(), r = C(0);
    return $t(() => {
      r.value = t.value.children.length > 3 ? 3 : t.value.children.length;
    }), (n, o) => (g(), B("div", {
      ref_key: "slot",
      ref: t,
      class: Yn("d-teaser-product space-y-10 xl:space-y-0 xl:space-x-10 grid grid-cols-1 lg:grid-cols-1 xl:grid-cols-" + r.value)
    }, [
      j(n.$slots, "default")
    ], 2));
  }
}), Ls = /* @__PURE__ */ _({
  __name: "risk-disclaimer",
  props: {
    title: {
      type: String
    },
    text: {
      type: String
    }
  },
  setup(e) {
    const t = e, r = k(() => ({
      title: t.title,
      text: t.text
    }));
    return (n, o) => (g(), m(f(Ka), { model: r.value }, null, 8, ["model"]));
  }
}), Ds = /* @__PURE__ */ _({
  __name: "space",
  props: {
    space: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (g(), B("div", {
      class: Yn(["spacer", {
        "pb-4": e.space === 1,
        "pb-8": e.space === 2,
        "pb-12": e.space === 3,
        "pb-16": e.space === 4,
        "pb-20": e.space === 5,
        "pb-24": e.space === 6,
        "pb-28": e.space === 7,
        "pb-32": e.space === 8,
        "pb-36": e.space === 9,
        "pb-40": e.space === 10,
        "pb-44": e.space === 11,
        "pb-48": e.space === 12
      }])
    }, null, 2));
  }
}), Ns = /* @__PURE__ */ _({
  __name: "content-box",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (r, n) => t.model?.type === "image-box" ? (g(), m(f(Wa), {
      key: 0,
      model: t.model.props
    }, null, 8, ["model"])) : (g(), m(f(Ja), {
      key: 1,
      content: t.model.props,
      type: t.model.type,
      "icon-marker-color": t.model.iconMarkerColor,
      "headline-type": t.model.headlineType
    }, null, 8, ["content", "type", "icon-marker-color", "headline-type"]));
  }
}), Fs = /* @__PURE__ */ _({
  __name: "page-overview",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, r) => (g(), m(f(Qa), {
      class: "d-article-page__article-page-overview",
      model: e.model
    }, null, 8, ["model"]));
  }
}), Us = /* @__PURE__ */ _({
  __name: "content-slider",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    return (r, n) => (g(), m(f(Za), {
      model: t.model,
      "background-type": t.model?.backgroundType,
      "headline-type": t.model?.headlineType,
      "page-name": t.model.pageName
    }, null, 8, ["model", "background-type", "headline-type", "page-name"]));
  }
});
function oa(e) {
  if (e.length > 10)
    throw new Error("Maximum of 10 answers allowed");
  const t = "ABCDEFGHIJ".split(""), r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  for (let o = 0; o < e.length; o++)
    r.set(e[o].id, t[o]), n.set(t[o], e[o].id);
  return {
    getFrontendId: (o) => r.get(o),
    getBackendId: (o) => n.get(o)
  };
}
const Es = /* @__PURE__ */ _({
  __name: "poll",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    let r;
    const n = k(() => {
      const s = t.model;
      r = oa(t.model.answers);
      for (const a of s.answers) {
        const i = r.getFrontendId(a.id);
        if (i === void 0)
          throw new Error(`Frontend id for answer ${a.id} should not be 'undefined'.`);
        a.id = i;
      }
      return s;
    });
    async function o(s) {
      const a = r.getBackendId(s.id);
      if (a === void 0)
        throw new Error(`Backend id for answer ${s.id} should not be 'undefined.'`);
      const u = await (await fetch(t.model.voteUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          answerId: a,
          blockId: t.model.blockId
        })
      })).json();
      for (const l of u) {
        const c = r.getFrontendId(l.id);
        if (c === void 0)
          throw new Error(`Frontend id for answer ${l.id} should not be 'undefined'.`);
        l.id = c;
      }
      return u;
    }
    return (s, a) => (g(), m(f(na), {
      model: n.value,
      "poll-callback": (i) => o(i),
      "page-name": e.model.pageName
    }, null, 8, ["model", "poll-callback", "page-name"]));
  }
}), Gs = /* @__PURE__ */ _({
  __name: "quiz",
  props: {
    model: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e;
    let r;
    const n = C([...t.model.answers]);
    Aa(
      () => [t.model.answers],
      () => {
        t.model.answers = n.value;
      },
      { deep: !0 }
      // ✅ Detects changes inside objects within the array
    ), Ia(() => {
      r = oa(t.model.answers);
      for (const s of n.value) {
        const a = r.getFrontendId(s.id);
        if (a === void 0)
          throw new Error(`Frontend id for answer ${s.id} should not be 'undefined'.`);
        s.id = a;
      }
    });
    function o(s) {
      const a = r.getBackendId(s.id);
      if (a === void 0)
        throw new Error(`Backend id for answer ${s.id} should not be 'undefined.'`);
      fetch(t.model.voteUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          answerId: a,
          blockId: t.model.blockId
        })
      });
    }
    return (s, a) => (g(), m(f(na), {
      model: e.model,
      onAnswerSelected: o,
      "page-name": e.model.pageName
    }, null, 8, ["model", "page-name"]));
  }
});
function X(e) {
  const t = window?.location.protocol + "//" + window?.location.host + window?.location.pathname, r = {}, n = Object.keys(e).map((i) => ({ key: i, type: e[i] }));
  function o() {
    if (window?.history) {
      const i = [];
      for (const l of n) {
        const c = r[l.key];
        if (c != null)
          if (Array.isArray(c))
            for (const d of c)
              d && d.length > 0 && i.push(l.key + "=" + encodeURIComponent(d));
          else c && c.length > 0 && i.push(l.key + "=" + encodeURIComponent(c));
      }
      let u = t;
      i.length > 0 && (u += "?" + i.join("&")), window?.history.replaceState("", "", u);
    }
  }
  function s(i, u) {
    if (u == null)
      r[i] = void 0;
    else if (Array.isArray(u)) {
      if (!u || u.length === 0)
        return;
      let l;
      Object.hasOwn(u[0], "filterOptions") ? l = u.find((c) => c.identifier === i)?.filterOptions[i] ?? [] : l = u, r[i] = l.filter((c) => c.isSelected).map((c) => c.identifier);
    } else typeof u == "string" ? r[i] = u : Object.hasOwn(u, "label") && (r[i] = u.value?.toString());
  }
  function a(i) {
    i = i == null || i.length == 0 ? window?.location.search : i;
    const u = new URLSearchParams(i);
    for (const l of n) {
      const c = u?.getAll(l.key);
      c?.length > 0 && (l.type === "array" ? r[l.key] = c.map((d) => decodeURIComponent(d)) : r[l.key] = decodeURIComponent(c[0]));
    }
  }
  return {
    updateUrl: () => o(),
    updateProperty: (i, u) => s(i, u),
    parseUrl: (i) => a(i),
    state: r
  };
}
function $(e = void 0) {
  e ??= "";
  let t;
  async function r(o) {
    t?.abort("Multiple Requests"), t = new AbortController();
    const s = await fetch(o, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      signal: t.signal
    });
    return s.status === 200 ? await s.json() : null;
  }
  async function n(o, s) {
    t?.abort("Multiple Requests"), t = new AbortController();
    const a = await fetch(e, {
      method: "POST",
      body: JSON.stringify(o),
      headers: {
        "Content-Type": "application/json"
      },
      signal: t.signal
    });
    return a.status === 200 ? await a.json() : null;
  }
  return {
    post: (o) => n(o),
    postUrl: (o) => r(o)
  };
}
function Hs(e) {
  return e?.filterOptions?.find((t) => t.isSelected)?.identifier;
}
function $s(e) {
  const t = {};
  if (!e)
    return {};
  for (const r of e)
    for (const n in r.filterOptions) {
      const o = r.filterOptions[n];
      t[n] = o.filter((s) => s.isSelected).map((s) => s.identifier);
    }
  return t;
}
function or(e) {
  return e?.selectedItem?.value;
}
const zs = /* @__PURE__ */ _({
  __name: "archive-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = $("Search"), n = X({
      term: "string",
      topic: "array",
      source: "array",
      format: "array",
      "publish-date": "string"
    });
    n.parseUrl(t.queryStringUrl);
    const o = Xa(), s = t.model.noResultsText && t.model.noResultsText.length > 0 ? t.model.noResultsText : "No Results";
    o.initStore(
      t.model.headline,
      t.model.introText,
      n.state.term == null ? "" : n.state.term,
      t.model.filters ?? [],
      t.model.flyoutResults,
      t.model.results,
      t.model.showGridFirst,
      !0,
      s,
      t.model.totalItemsCount ?? 0,
      (i) => a(i),
      t.model.hideSearchBar,
      t.model.teaserHero,
      t.model.searchBoxPlaceholder,
      t.pageName
    );
    async function a(i) {
      const u = i.eventType === Ya.SearchTermHasChanged;
      n.updateProperty("term", i.searchTerm), n.updateProperty("topic", i.filters), n.updateProperty("source", i.filters), n.updateProperty("format", i.filters), n.updateProperty("publish-date", i.filters), n.updateUrl();
      const l = await r.post({
        searchTerm: i.searchTerm,
        filters: u ? null : $s(i.filters),
        eventType: i.eventType,
        lazyLoadEventData: u ? null : i.lazyLoadEventData
      });
      return l != null ? u ? {
        flyouts: l.flyouts,
        results: o.results,
        filters: o.filters,
        totalItemsCount: o.totalItemsCount
      } : {
        flyouts: o.flyoutResults,
        results: l.results,
        filters: l.filters ?? o.filters,
        totalItemsCount: l.totalCount
      } : {
        results: o.results,
        flyouts: o.flyoutResults,
        filters: o.filters,
        totalItemsCount: o.totalItemsCount
      };
    }
    return (i, u) => (g(), m(f(eo), null, {
      beforesearch: O(() => [
        j(i.$slots, "beforesearch")
      ]),
      beforeend: O(() => [
        j(i.$slots, "beforeend")
      ]),
      _: 3
    }));
  }
}), Ks = /* @__PURE__ */ _({
  __name: "calendar-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(e) {
    const t = e, r = C(t.model), n = X({
      year: "string"
    });
    n.parseUrl(t.queryStringUrl);
    const o = $("events"), s = async (a, i) => {
      n.updateProperty("year", a.identifier), n.updateUrl();
      const u = await o.post({
        year: n.state.year
      });
      u && (r.value = { ...t.model, eventList: u });
    };
    return (a, i) => (g(), m(f(to), {
      model: r.value,
      "page-name": r.value.pageName,
      onFilterChanged: s
    }, null, 8, ["model", "page-name"]));
  }
}), Ws = /* @__PURE__ */ _({
  __name: "faq-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    return (t, r) => (g(), m(f(ro), {
      model: e.model,
      "page-name": e.pageName
    }, null, 8, ["model", "page-name"]));
  }
}), Js = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Qs = /* @__PURE__ */ _({
  __name: "search-result-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = $("search"), n = X({
      term: "string",
      category: "string",
      filterby: "string",
      sortby: "string"
    });
    n.parseUrl(t.queryStringUrl);
    const o = no();
    Js && window.addEventListener("popstate", () => {
      n.parseUrl(), o.$patch({
        searchTerm: n.state.term ?? ""
      });
    }), o.initStore(
      n.state.term ?? "",
      0,
      // Selected Tab Index
      t.model.props?.flyouts,
      t.model.props?.results,
      t.model.props?.filters,
      (i) => a(i),
      void 0,
      t.pageName
    );
    const s = C(t.model.props);
    async function a(i) {
      if (i.searchTerm === "") return s.value;
      const u = i.eventType === ao.SearchTermHasChanged;
      u || (n.updateProperty("term", i.searchTerm), n.updateProperty("category", i.filters?.filter?.filterOptions), n.updateProperty("filterby", i.filters?.filterBy?.selectedItem), n.updateProperty("sortby", i.filters?.sortBy?.selectedItem), n.updateUrl());
      const l = await r.post({
        searchTerm: i.searchTerm,
        category: u ? null : Hs(i.filters?.filter),
        sortBy: u ? null : or(i.filters?.sortBy)?.toString(),
        filterBy: u ? null : or(i.filters?.filterBy)?.toString(),
        eventType: i.eventType,
        lazyLoadEventData: u ? null : i.lazyLoadEventData
      });
      return l != null ? u ? {
        ...l,
        filters: o.filters,
        results: o.results
      } : {
        ...l,
        flyouts: o.flyoutResults
      } : { ...s.value };
    }
    return (i, u) => (g(), m(f(oo)));
  }
}), Zs = /* @__PURE__ */ _({
  __name: "property-gallery-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = t.model.results;
    so().initStore(
      t.model.filters,
      t.model.results,
      async (l) => {
        const c = s(r, l.filters), d = o(t.model.results, l.filters.filter((p) => p.isSelected === !0));
        return Promise.resolve({
          filters: c,
          results: d
        });
      },
      t.pageName
    );
    function o(l, c) {
      let d = l;
      for (const p of c)
        switch (p.daclFilterType) {
          case "string":
            d = i(d, p);
            break;
          case "number-range":
            d = u(d, p);
            break;
        }
      return d;
    }
    function s(l, c) {
      return c.map((d) => {
        const p = d.identifier === "priceRange", h = c.filter(
          (T) => T.identifier !== d.identifier
        ), v = l.filter(
          (T) => h.every((b) => {
            const V = Object.values(b.filterOptions).flat().filter((A) => A.isSelected);
            if (V.length === 0) return !0;
            if (b.identifier === "priceRange") {
              const A = V, I = T.marketValueSortValue;
              return A.some(
                (S) => I >= S.lowerBound && I <= S.upperBound
              );
            } else {
              const A = T[b.identifier];
              return V.map((S) => S.name?.toLowerCase()).includes(String(A ?? "").toLowerCase());
            }
          })
        ), w = new Set(
          v.map((T) => {
            const b = p ? T.marketValueSortValue : T[d.identifier];
            return d.identifier === "priceRange" ? b : String(b ?? "").toLowerCase();
          })
        );
        let q;
        return p ? q = d.filterOptions[d.identifier].map((T) => ({
          ...T,
          isDisabled: !a(T, Array.from(w))
        })) : q = d.filterOptions[d.identifier].map((T) => ({
          ...T,
          isDisabled: !w.has(T.name?.toLowerCase())
        })), {
          ...d,
          filterOptions: {
            ...d.filterOptions,
            [d.identifier]: q
          }
        };
      });
    }
    function a(l, c) {
      const d = l;
      if (d.lowerBound !== void 0 && d.upperBound !== null) {
        for (const p of c)
          if (p >= d.lowerBound && p <= d?.upperBound)
            return !0;
      }
      return !1;
    }
    function i(l, c) {
      const p = c.filterOptions[c.identifier].filter((v) => v.isSelected === !0).map((v) => v.name);
      return l.filter((v) => p.includes(v[c.identifier]));
    }
    function u(l, c) {
      const p = c.filterOptions[c.identifier].filter((v) => v.isSelected === !0);
      return l.filter((v) => p.find((w) => v.marketValueSortValue == null ? !1 : v.marketValueSortValue >= w.lowerBound && (v.marketValueSortValue < w.upperBound || w.inclusiveUpperBound && v.marketValueSortValue == w.upperBound)));
    }
    return (l, c) => (g(), m(f(io), {
      headline: t.model.headline ?? "",
      "intro-text": t.model.introText ?? "",
      "hide-satellite-control": !0,
      "hide-street-view-control": !0
    }, null, 8, ["headline", "intro-text"]));
  }
});
var Xs = /* @__PURE__ */ ((e) => (e.Ticker = "Ticker", e.WKN = "WKN", e.ISIN = "ISIN", e))(Xs || {});
const Ys = /* @__PURE__ */ _({
  __name: "property-detail-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e;
    return (r, n) => (g(), m(f(uo), {
      model: e.model,
      "hide-satellite-control": !0,
      "hide-street-view-control": !0,
      "page-name": t.pageName
    }, null, 8, ["model", "page-name"]));
  }
}), ei = /* @__PURE__ */ _({
  __name: "glossary-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    return (t, r) => (g(), m(f(lo), {
      model: e.model,
      "page-name": e.pageName
    }, null, 8, ["model", "page-name"]));
  }
}), ti = /* @__PURE__ */ _({
  __name: "media-releases-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = $("Search"), n = X({
      term: "string",
      year: "string"
    });
    n.parseUrl(t.queryStringUrl);
    const o = co();
    o.initStore(
      t.model.filter,
      t.model.flyoutResults,
      t.model.results,
      t.model.showNumberOfResults ?? !0,
      n.state.term ?? "",
      (a) => s(a),
      t.pageName
    );
    async function s(a) {
      if (a.eventType == tr.SearchTermBlur)
        return {
          results: o.results,
          flyouts: o.flyoutResults,
          filter: o.filter,
          showNumberOfResults: o.showNumberOfResults
        };
      const i = a.eventType === tr.SearchTermHasChanged;
      n.updateProperty("term", a.searchTerm), n.updateProperty("year", a.selectedFilter?.identifier), n.updateUrl();
      const u = await r.post({
        searchTerm: a.searchTerm,
        year: n.state.year,
        eventType: a.eventType
      });
      return u != null ? i ? {
        flyouts: u.flyouts,
        results: o.results,
        filter: o.filter,
        showNumberOfResults: o.showNumberOfResults
      } : {
        results: u.results,
        flyouts: o.flyoutResults,
        filter: u.filter,
        showNumberOfResults: o.showNumberOfResults
      } : {
        results: o.results,
        flyouts: o.flyoutResults,
        filter: o.filter,
        showNumberOfResults: o.showNumberOfResults
      };
    }
    return (a, i) => (g(), m(f(fo), {
      headline: t.model.headline,
      "intro-text": t.model.introText,
      "page-disclaimer": "test"
    }, null, 8, ["headline", "intro-text"]));
  }
}), ri = /* @__PURE__ */ _({
  __name: "product-buying-process-page",
  props: {
    model: {},
    queryStringUrl: {}
  },
  setup(e) {
    const t = e, r = k(() => t.model.sortBy === "AlphabeticalAZ");
    return (n, o) => (g(), m(f(zt), { id: "product-buying-process" }, {
      default: O(() => [
        D(f(po), {
          model: t.model,
          "partners-alphabetically-sorted": r.value,
          "page-name": t.model.pageName
        }, null, 8, ["model", "partners-alphabetically-sorted", "page-name"])
      ]),
      _: 1
    }));
  }
}), ni = { class: "grid grid-cols-3 gap-4" }, ai = { class: "col-span-3" }, oi = { class: "col-span-3 ml-auto" }, si = /* @__PURE__ */ _({
  __name: "login-page",
  props: {
    model: {},
    queryStringUrl: {},
    pageName: {}
  },
  setup(e) {
    const t = e, r = C(t.model), n = C(""), o = C(""), s = C(Q.Default), a = window != null, i = () => ({
      contentUrl: "",
      title: r.value.submitButtonText,
      text: r.value.submitButtonText,
      isLocked: !1,
      target: "",
      linkType: To.Default,
      tealiumTrackingModel: {
        eventSource: t.pageName,
        eventComponentName: "Flux Login Page",
        eventTitle: "Submit button"
      }
    }), u = async (c) => {
      n.value = c;
    }, l = async () => {
      if (!n.value || n.value === "") {
        s.value = Q.Invalid, o.value = r.value.passwordRequiredText;
        return;
      } else
        s.value = Q.Valid;
      const c = document.getElementsByName("__RequestVerificationToken")[0], d = new URLSearchParams({
        currentPageId: t.model.currentPageId.toString(),
        currentPageLanguage: t.model.currentPageLanguage,
        returnUrl: t.model.returnUrl ?? "",
        password: n.value
      }).toString(), h = await fetch(`/fluxlogin?${d.toString()}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          RequestVerificationToken: c.value ? c.value : ""
        }
      });
      if (h.redirected && a)
        window.location.href = h.url;
      else {
        const v = await h.json();
        r.value = v, v.errorMessage && (s.value = Q.Invalid, o.value = v.errorMessage);
      }
      console.log(h);
    };
    return (c, d) => (g(), m(f(ra), {
      id: 1,
      "layout-type": f(U).TwoThirdsOneThird,
      "no-margin": !1,
      "stretched-column": f(ta).None,
      "content-width": !0,
      "vertical-align-content-col-one": f(rr).Center,
      "vertical-align-content-col-two": f(rr).Center
    }, {
      colone: O(() => [
        J("form", {
          onSubmit: d[0] || (d[0] = Zn(() => {
          }, ["prevent"]))
        }, [
          r.value.title || r.value.description ? (g(), m(f(go), {
            key: 0,
            class: "d-form-builder__header mb-4",
            model: {
              headline: r.value.title,
              introText: r.value.description
            },
            "base-heading-type": f(ho).H1
          }, null, 8, ["model", "base-heading-type"])) : x("", !0),
          J("div", ni, [
            J("div", ai, [
              D(f(mo), {
                "input-type": f(yo).Password,
                "input-value": n.value,
                label: r.value.passwordInputLabel,
                onValueChanged: u,
                state: s.value,
                "error-text": o.value,
                "label-position": f(vo).Up
              }, null, 8, ["input-type", "input-value", "label", "state", "error-text", "label-position"])
            ]),
            J("div", oi, [
              D(f(_o), {
                "button-type": f(wo).Button,
                type: f(bo).Primary,
                "link-model": i(),
                onClick: l
              }, null, 8, ["button-type", "type", "link-model"])
            ])
          ])
        ], 32)
      ]),
      coltwo: O(() => [...d[1] || (d[1] = [])]),
      _: 1
    }, 8, ["layout-type", "stretched-column", "vertical-align-content-col-one", "vertical-align-content-col-two"]));
  }
}), Kt = async (e, t) => {
  t.link?.href && (await fetch(t.link?.href, {
    method: "POST"
  }), location.reload());
}, ii = /* @__PURE__ */ _({
  __name: "pageframe-patternlab-footer",
  props: {
    model: {
      type: Object,
      required: !1,
      default: null
    }
  },
  setup(e) {
    return (t, r) => e.model ? (g(), m(f(Co), {
      key: 0,
      model: e.model,
      onAudienceChanged: f(Kt)
    }, null, 8, ["model", "onAudienceChanged"])) : x("", !0);
  }
});
function sa(e, t) {
  const r = $();
  let n;
  return {
    search: async (a) => {
      if (!e)
        return;
      e = decodeURI(e);
      const i = e.replace("{searchTerm}", a).replace("{limit}", "5"), u = await r.postUrl(i);
      u && t(u);
    },
    searchClear: () => {
      t(n);
    },
    setStaticResult: (a) => {
      n = a;
    }
  };
}
var Z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ui(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var se, sr;
function li() {
  if (sr) return se;
  sr = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return se = e, se;
}
var ie, ir;
function Y() {
  if (ir) return ie;
  ir = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return ie = e, ie;
}
var ue, ur;
function ee() {
  if (ur) return ue;
  ur = 1;
  var e = Y();
  function t(r, n) {
    for (var o = r.length; o--; )
      if (e(r[o][0], n))
        return o;
    return -1;
  }
  return ue = t, ue;
}
var le, lr;
function ci() {
  if (lr) return le;
  lr = 1;
  var e = ee(), t = Array.prototype, r = t.splice;
  function n(o) {
    var s = this.__data__, a = e(s, o);
    if (a < 0)
      return !1;
    var i = s.length - 1;
    return a == i ? s.pop() : r.call(s, a, 1), --this.size, !0;
  }
  return le = n, le;
}
var ce, cr;
function di() {
  if (cr) return ce;
  cr = 1;
  var e = ee();
  function t(r) {
    var n = this.__data__, o = e(n, r);
    return o < 0 ? void 0 : n[o][1];
  }
  return ce = t, ce;
}
var de, dr;
function fi() {
  if (dr) return de;
  dr = 1;
  var e = ee();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return de = t, de;
}
var fe, fr;
function pi() {
  if (fr) return fe;
  fr = 1;
  var e = ee();
  function t(r, n) {
    var o = this.__data__, s = e(o, r);
    return s < 0 ? (++this.size, o.push([r, n])) : o[s][1] = n, this;
  }
  return fe = t, fe;
}
var pe, pr;
function te() {
  if (pr) return pe;
  pr = 1;
  var e = li(), t = ci(), r = di(), n = fi(), o = pi();
  function s(a) {
    var i = -1, u = a == null ? 0 : a.length;
    for (this.clear(); ++i < u; ) {
      var l = a[i];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = o, pe = s, pe;
}
var ge, gr;
function gi() {
  if (gr) return ge;
  gr = 1;
  var e = te();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return ge = t, ge;
}
var he, hr;
function hi() {
  if (hr) return he;
  hr = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return he = e, he;
}
var me, mr;
function mi() {
  if (mr) return me;
  mr = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return me = e, me;
}
var ve, vr;
function vi() {
  if (vr) return ve;
  vr = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return ve = e, ve;
}
var ye, yr;
function ia() {
  if (yr) return ye;
  yr = 1;
  var e = typeof Z == "object" && Z && Z.Object === Object && Z;
  return ye = e, ye;
}
var _e, _r;
function N() {
  if (_r) return _e;
  _r = 1;
  var e = ia(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return _e = r, _e;
}
var be, br;
function ua() {
  if (br) return be;
  br = 1;
  var e = N(), t = e.Symbol;
  return be = t, be;
}
var we, wr;
function yi() {
  if (wr) return we;
  wr = 1;
  var e = ua(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, o = e ? e.toStringTag : void 0;
  function s(a) {
    var i = r.call(a, o), u = a[o];
    try {
      a[o] = void 0;
      var l = !0;
    } catch {
    }
    var c = n.call(a);
    return l && (i ? a[o] = u : delete a[o]), c;
  }
  return we = s, we;
}
var Te, Tr;
function _i() {
  if (Tr) return Te;
  Tr = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return Te = r, Te;
}
var Ce, Cr;
function re() {
  if (Cr) return Ce;
  Cr = 1;
  var e = ua(), t = yi(), r = _i(), n = "[object Null]", o = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function a(i) {
    return i == null ? i === void 0 ? o : n : s && s in Object(i) ? t(i) : r(i);
  }
  return Ce = a, Ce;
}
var qe, qr;
function L() {
  if (qr) return qe;
  qr = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return qe = e, qe;
}
var Se, Sr;
function Wt() {
  if (Sr) return Se;
  Sr = 1;
  var e = re(), t = L(), r = "[object AsyncFunction]", n = "[object Function]", o = "[object GeneratorFunction]", s = "[object Proxy]";
  function a(i) {
    if (!t(i))
      return !1;
    var u = e(i);
    return u == n || u == o || u == r || u == s;
  }
  return Se = a, Se;
}
var Pe, Pr;
function bi() {
  if (Pr) return Pe;
  Pr = 1;
  var e = N(), t = e["__core-js_shared__"];
  return Pe = t, Pe;
}
var Re, Rr;
function wi() {
  if (Rr) return Re;
  Rr = 1;
  var e = bi(), t = (function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  })();
  function r(n) {
    return !!t && t in n;
  }
  return Re = r, Re;
}
var Oe, Or;
function Ti() {
  if (Or) return Oe;
  Or = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Oe = r, Oe;
}
var Ae, Ar;
function Ci() {
  if (Ar) return Ae;
  Ar = 1;
  var e = Wt(), t = wi(), r = L(), n = Ti(), o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, a = Function.prototype, i = Object.prototype, u = a.toString, l = i.hasOwnProperty, c = RegExp(
    "^" + u.call(l).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(p) {
    if (!r(p) || t(p))
      return !1;
    var h = e(p) ? c : s;
    return h.test(n(p));
  }
  return Ae = d, Ae;
}
var Ie, Ir;
function qi() {
  if (Ir) return Ie;
  Ir = 1;
  function e(t, r) {
    return t?.[r];
  }
  return Ie = e, Ie;
}
var je, jr;
function Jt() {
  if (jr) return je;
  jr = 1;
  var e = Ci(), t = qi();
  function r(n, o) {
    var s = t(n, o);
    return e(s) ? s : void 0;
  }
  return je = r, je;
}
var ke, kr;
function la() {
  if (kr) return ke;
  kr = 1;
  var e = Jt(), t = N(), r = e(t, "Map");
  return ke = r, ke;
}
var xe, xr;
function ne() {
  if (xr) return xe;
  xr = 1;
  var e = Jt(), t = e(Object, "create");
  return xe = t, xe;
}
var Be, Br;
function Si() {
  if (Br) return Be;
  Br = 1;
  var e = ne();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Be = t, Be;
}
var Ve, Vr;
function Pi() {
  if (Vr) return Ve;
  Vr = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return Ve = e, Ve;
}
var Me, Mr;
function Ri() {
  if (Mr) return Me;
  Mr = 1;
  var e = ne(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function o(s) {
    var a = this.__data__;
    if (e) {
      var i = a[s];
      return i === t ? void 0 : i;
    }
    return n.call(a, s) ? a[s] : void 0;
  }
  return Me = o, Me;
}
var Le, Lr;
function Oi() {
  if (Lr) return Le;
  Lr = 1;
  var e = ne(), t = Object.prototype, r = t.hasOwnProperty;
  function n(o) {
    var s = this.__data__;
    return e ? s[o] !== void 0 : r.call(s, o);
  }
  return Le = n, Le;
}
var De, Dr;
function Ai() {
  if (Dr) return De;
  Dr = 1;
  var e = ne(), t = "__lodash_hash_undefined__";
  function r(n, o) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = e && o === void 0 ? t : o, this;
  }
  return De = r, De;
}
var Ne, Nr;
function Ii() {
  if (Nr) return Ne;
  Nr = 1;
  var e = Si(), t = Pi(), r = Ri(), n = Oi(), o = Ai();
  function s(a) {
    var i = -1, u = a == null ? 0 : a.length;
    for (this.clear(); ++i < u; ) {
      var l = a[i];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = o, Ne = s, Ne;
}
var Fe, Fr;
function ji() {
  if (Fr) return Fe;
  Fr = 1;
  var e = Ii(), t = te(), r = la();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return Fe = n, Fe;
}
var Ue, Ur;
function ki() {
  if (Ur) return Ue;
  Ur = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Ue = e, Ue;
}
var Ee, Er;
function ae() {
  if (Er) return Ee;
  Er = 1;
  var e = ki();
  function t(r, n) {
    var o = r.__data__;
    return e(n) ? o[typeof n == "string" ? "string" : "hash"] : o.map;
  }
  return Ee = t, Ee;
}
var Ge, Gr;
function xi() {
  if (Gr) return Ge;
  Gr = 1;
  var e = ae();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Ge = t, Ge;
}
var He, Hr;
function Bi() {
  if (Hr) return He;
  Hr = 1;
  var e = ae();
  function t(r) {
    return e(this, r).get(r);
  }
  return He = t, He;
}
var $e, $r;
function Vi() {
  if ($r) return $e;
  $r = 1;
  var e = ae();
  function t(r) {
    return e(this, r).has(r);
  }
  return $e = t, $e;
}
var ze, zr;
function Mi() {
  if (zr) return ze;
  zr = 1;
  var e = ae();
  function t(r, n) {
    var o = e(this, r), s = o.size;
    return o.set(r, n), this.size += o.size == s ? 0 : 1, this;
  }
  return ze = t, ze;
}
var Ke, Kr;
function Li() {
  if (Kr) return Ke;
  Kr = 1;
  var e = ji(), t = xi(), r = Bi(), n = Vi(), o = Mi();
  function s(a) {
    var i = -1, u = a == null ? 0 : a.length;
    for (this.clear(); ++i < u; ) {
      var l = a[i];
      this.set(l[0], l[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = t, s.prototype.get = r, s.prototype.has = n, s.prototype.set = o, Ke = s, Ke;
}
var We, Wr;
function Di() {
  if (Wr) return We;
  Wr = 1;
  var e = te(), t = la(), r = Li(), n = 200;
  function o(s, a) {
    var i = this.__data__;
    if (i instanceof e) {
      var u = i.__data__;
      if (!t || u.length < n - 1)
        return u.push([s, a]), this.size = ++i.size, this;
      i = this.__data__ = new r(u);
    }
    return i.set(s, a), this.size = i.size, this;
  }
  return We = o, We;
}
var Je, Jr;
function Ni() {
  if (Jr) return Je;
  Jr = 1;
  var e = te(), t = gi(), r = hi(), n = mi(), o = vi(), s = Di();
  function a(i) {
    var u = this.__data__ = new e(i);
    this.size = u.size;
  }
  return a.prototype.clear = t, a.prototype.delete = r, a.prototype.get = n, a.prototype.has = o, a.prototype.set = s, Je = a, Je;
}
var Qe, Qr;
function ca() {
  if (Qr) return Qe;
  Qr = 1;
  var e = Jt(), t = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Qe = t, Qe;
}
var Ze, Zr;
function Qt() {
  if (Zr) return Ze;
  Zr = 1;
  var e = ca();
  function t(r, n, o) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : r[n] = o;
  }
  return Ze = t, Ze;
}
var Xe, Xr;
function da() {
  if (Xr) return Xe;
  Xr = 1;
  var e = Qt(), t = Y();
  function r(n, o, s) {
    (s !== void 0 && !t(n[o], s) || s === void 0 && !(o in n)) && e(n, o, s);
  }
  return Xe = r, Xe;
}
var Ye, Yr;
function Fi() {
  if (Yr) return Ye;
  Yr = 1;
  function e(t) {
    return function(r, n, o) {
      for (var s = -1, a = Object(r), i = o(r), u = i.length; u--; ) {
        var l = i[t ? u : ++s];
        if (n(a[l], l, a) === !1)
          break;
      }
      return r;
    };
  }
  return Ye = e, Ye;
}
var et, en;
function Ui() {
  if (en) return et;
  en = 1;
  var e = Fi(), t = e();
  return et = t, et;
}
var E = { exports: {} };
E.exports;
var tn;
function Ei() {
  return tn || (tn = 1, (function(e, t) {
    var r = N(), n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, s = o && o.exports === n, a = s ? r.Buffer : void 0, i = a ? a.allocUnsafe : void 0;
    function u(l, c) {
      if (c)
        return l.slice();
      var d = l.length, p = i ? i(d) : new l.constructor(d);
      return l.copy(p), p;
    }
    e.exports = u;
  })(E, E.exports)), E.exports;
}
var tt, rn;
function Gi() {
  if (rn) return tt;
  rn = 1;
  var e = N(), t = e.Uint8Array;
  return tt = t, tt;
}
var rt, nn;
function Hi() {
  if (nn) return rt;
  nn = 1;
  var e = Gi();
  function t(r) {
    var n = new r.constructor(r.byteLength);
    return new e(n).set(new e(r)), n;
  }
  return rt = t, rt;
}
var nt, an;
function $i() {
  if (an) return nt;
  an = 1;
  var e = Hi();
  function t(r, n) {
    var o = n ? e(r.buffer) : r.buffer;
    return new r.constructor(o, r.byteOffset, r.length);
  }
  return nt = t, nt;
}
var at, on;
function zi() {
  if (on) return at;
  on = 1;
  function e(t, r) {
    var n = -1, o = t.length;
    for (r || (r = Array(o)); ++n < o; )
      r[n] = t[n];
    return r;
  }
  return at = e, at;
}
var ot, sn;
function Ki() {
  if (sn) return ot;
  sn = 1;
  var e = L(), t = Object.create, r = /* @__PURE__ */ (function() {
    function n() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      n.prototype = o;
      var s = new n();
      return n.prototype = void 0, s;
    };
  })();
  return ot = r, ot;
}
var st, un;
function Wi() {
  if (un) return st;
  un = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return st = e, st;
}
var it, ln;
function fa() {
  if (ln) return it;
  ln = 1;
  var e = Wi(), t = e(Object.getPrototypeOf, Object);
  return it = t, it;
}
var ut, cn;
function pa() {
  if (cn) return ut;
  cn = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, o = typeof n == "function" && n.prototype || e;
    return r === o;
  }
  return ut = t, ut;
}
var lt, dn;
function Ji() {
  if (dn) return lt;
  dn = 1;
  var e = Ki(), t = fa(), r = pa();
  function n(o) {
    return typeof o.constructor == "function" && !r(o) ? e(t(o)) : {};
  }
  return lt = n, lt;
}
var ct, fn;
function z() {
  if (fn) return ct;
  fn = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return ct = e, ct;
}
var dt, pn;
function Qi() {
  if (pn) return dt;
  pn = 1;
  var e = re(), t = z(), r = "[object Arguments]";
  function n(o) {
    return t(o) && e(o) == r;
  }
  return dt = n, dt;
}
var ft, gn;
function ga() {
  if (gn) return ft;
  gn = 1;
  var e = Qi(), t = z(), r = Object.prototype, n = r.hasOwnProperty, o = r.propertyIsEnumerable, s = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(a) {
    return t(a) && n.call(a, "callee") && !o.call(a, "callee");
  };
  return ft = s, ft;
}
var pt, hn;
function ha() {
  if (hn) return pt;
  hn = 1;
  var e = Array.isArray;
  return pt = e, pt;
}
var gt, mn;
function ma() {
  if (mn) return gt;
  mn = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return gt = t, gt;
}
var ht, vn;
function Zt() {
  if (vn) return ht;
  vn = 1;
  var e = Wt(), t = ma();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return ht = r, ht;
}
var mt, yn;
function Zi() {
  if (yn) return mt;
  yn = 1;
  var e = Zt(), t = z();
  function r(n) {
    return t(n) && e(n);
  }
  return mt = r, mt;
}
var G = { exports: {} }, vt, _n;
function Xi() {
  if (_n) return vt;
  _n = 1;
  function e() {
    return !1;
  }
  return vt = e, vt;
}
G.exports;
var bn;
function va() {
  return bn || (bn = 1, (function(e, t) {
    var r = N(), n = Xi(), o = t && !t.nodeType && t, s = o && !0 && e && !e.nodeType && e, a = s && s.exports === o, i = a ? r.Buffer : void 0, u = i ? i.isBuffer : void 0, l = u || n;
    e.exports = l;
  })(G, G.exports)), G.exports;
}
var yt, wn;
function Yi() {
  if (wn) return yt;
  wn = 1;
  var e = re(), t = fa(), r = z(), n = "[object Object]", o = Function.prototype, s = Object.prototype, a = o.toString, i = s.hasOwnProperty, u = a.call(Object);
  function l(c) {
    if (!r(c) || e(c) != n)
      return !1;
    var d = t(c);
    if (d === null)
      return !0;
    var p = i.call(d, "constructor") && d.constructor;
    return typeof p == "function" && p instanceof p && a.call(p) == u;
  }
  return yt = l, yt;
}
var _t, Tn;
function eu() {
  if (Tn) return _t;
  Tn = 1;
  var e = re(), t = ma(), r = z(), n = "[object Arguments]", o = "[object Array]", s = "[object Boolean]", a = "[object Date]", i = "[object Error]", u = "[object Function]", l = "[object Map]", c = "[object Number]", d = "[object Object]", p = "[object RegExp]", h = "[object Set]", v = "[object String]", w = "[object WeakMap]", q = "[object ArrayBuffer]", T = "[object DataView]", b = "[object Float32Array]", K = "[object Float64Array]", V = "[object Int8Array]", A = "[object Int16Array]", I = "[object Int32Array]", S = "[object Uint8Array]", P = "[object Uint8ClampedArray]", W = "[object Uint16Array]", R = "[object Uint32Array]", y = {};
  y[b] = y[K] = y[V] = y[A] = y[I] = y[S] = y[P] = y[W] = y[R] = !0, y[n] = y[o] = y[q] = y[s] = y[T] = y[a] = y[i] = y[u] = y[l] = y[c] = y[d] = y[p] = y[h] = y[v] = y[w] = !1;
  function F(M) {
    return r(M) && t(M.length) && !!y[e(M)];
  }
  return _t = F, _t;
}
var bt, Cn;
function tu() {
  if (Cn) return bt;
  Cn = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return bt = e, bt;
}
var H = { exports: {} };
H.exports;
var qn;
function ru() {
  return qn || (qn = 1, (function(e, t) {
    var r = ia(), n = t && !t.nodeType && t, o = n && !0 && e && !e.nodeType && e, s = o && o.exports === n, a = s && r.process, i = (function() {
      try {
        var u = o && o.require && o.require("util").types;
        return u || a && a.binding && a.binding("util");
      } catch {
      }
    })();
    e.exports = i;
  })(H, H.exports)), H.exports;
}
var wt, Sn;
function ya() {
  if (Sn) return wt;
  Sn = 1;
  var e = eu(), t = tu(), r = ru(), n = r && r.isTypedArray, o = n ? t(n) : e;
  return wt = o, wt;
}
var Tt, Pn;
function _a() {
  if (Pn) return Tt;
  Pn = 1;
  function e(t, r) {
    if (!(r === "constructor" && typeof t[r] == "function") && r != "__proto__")
      return t[r];
  }
  return Tt = e, Tt;
}
var Ct, Rn;
function nu() {
  if (Rn) return Ct;
  Rn = 1;
  var e = Qt(), t = Y(), r = Object.prototype, n = r.hasOwnProperty;
  function o(s, a, i) {
    var u = s[a];
    (!(n.call(s, a) && t(u, i)) || i === void 0 && !(a in s)) && e(s, a, i);
  }
  return Ct = o, Ct;
}
var qt, On;
function au() {
  if (On) return qt;
  On = 1;
  var e = nu(), t = Qt();
  function r(n, o, s, a) {
    var i = !s;
    s || (s = {});
    for (var u = -1, l = o.length; ++u < l; ) {
      var c = o[u], d = a ? a(s[c], n[c], c, s, n) : void 0;
      d === void 0 && (d = n[c]), i ? t(s, c, d) : e(s, c, d);
    }
    return s;
  }
  return qt = r, qt;
}
var St, An;
function ou() {
  if (An) return St;
  An = 1;
  function e(t, r) {
    for (var n = -1, o = Array(t); ++n < t; )
      o[n] = r(n);
    return o;
  }
  return St = e, St;
}
var Pt, In;
function ba() {
  if (In) return Pt;
  In = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, o) {
    var s = typeof n;
    return o = o ?? e, !!o && (s == "number" || s != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < o;
  }
  return Pt = r, Pt;
}
var Rt, jn;
function su() {
  if (jn) return Rt;
  jn = 1;
  var e = ou(), t = ga(), r = ha(), n = va(), o = ba(), s = ya(), a = Object.prototype, i = a.hasOwnProperty;
  function u(l, c) {
    var d = r(l), p = !d && t(l), h = !d && !p && n(l), v = !d && !p && !h && s(l), w = d || p || h || v, q = w ? e(l.length, String) : [], T = q.length;
    for (var b in l)
      (c || i.call(l, b)) && !(w && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      v && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      o(b, T))) && q.push(b);
    return q;
  }
  return Rt = u, Rt;
}
var Ot, kn;
function iu() {
  if (kn) return Ot;
  kn = 1;
  function e(t) {
    var r = [];
    if (t != null)
      for (var n in Object(t))
        r.push(n);
    return r;
  }
  return Ot = e, Ot;
}
var At, xn;
function uu() {
  if (xn) return At;
  xn = 1;
  var e = L(), t = pa(), r = iu(), n = Object.prototype, o = n.hasOwnProperty;
  function s(a) {
    if (!e(a))
      return r(a);
    var i = t(a), u = [];
    for (var l in a)
      l == "constructor" && (i || !o.call(a, l)) || u.push(l);
    return u;
  }
  return At = s, At;
}
var It, Bn;
function wa() {
  if (Bn) return It;
  Bn = 1;
  var e = su(), t = uu(), r = Zt();
  function n(o) {
    return r(o) ? e(o, !0) : t(o);
  }
  return It = n, It;
}
var jt, Vn;
function lu() {
  if (Vn) return jt;
  Vn = 1;
  var e = au(), t = wa();
  function r(n) {
    return e(n, t(n));
  }
  return jt = r, jt;
}
var kt, Mn;
function cu() {
  if (Mn) return kt;
  Mn = 1;
  var e = da(), t = Ei(), r = $i(), n = zi(), o = Ji(), s = ga(), a = ha(), i = Zi(), u = va(), l = Wt(), c = L(), d = Yi(), p = ya(), h = _a(), v = lu();
  function w(q, T, b, K, V, A, I) {
    var S = h(q, b), P = h(T, b), W = I.get(P);
    if (W) {
      e(q, b, W);
      return;
    }
    var R = A ? A(S, P, b + "", q, T, I) : void 0, y = R === void 0;
    if (y) {
      var F = a(P), M = !F && u(P), Xt = !F && !M && p(P);
      R = P, F || M || Xt ? a(S) ? R = S : i(S) ? R = n(S) : M ? (y = !1, R = t(P, !0)) : Xt ? (y = !1, R = r(P, !0)) : R = [] : d(P) || s(P) ? (R = S, s(S) ? R = v(S) : (!c(S) || l(S)) && (R = o(P))) : y = !1;
    }
    y && (I.set(P, R), V(R, P, K, A, I), I.delete(P)), e(q, b, R);
  }
  return kt = w, kt;
}
var xt, Ln;
function du() {
  if (Ln) return xt;
  Ln = 1;
  var e = Ni(), t = da(), r = Ui(), n = cu(), o = L(), s = wa(), a = _a();
  function i(u, l, c, d, p) {
    u !== l && r(l, function(h, v) {
      if (p || (p = new e()), o(h))
        n(u, l, v, c, i, d, p);
      else {
        var w = d ? d(a(u, v), h, v + "", u, l, p) : void 0;
        w === void 0 && (w = h), t(u, v, w);
      }
    }, s);
  }
  return xt = i, xt;
}
var Bt, Dn;
function Ta() {
  if (Dn) return Bt;
  Dn = 1;
  function e(t) {
    return t;
  }
  return Bt = e, Bt;
}
var Vt, Nn;
function fu() {
  if (Nn) return Vt;
  Nn = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return Vt = e, Vt;
}
var Mt, Fn;
function pu() {
  if (Fn) return Mt;
  Fn = 1;
  var e = fu(), t = Math.max;
  function r(n, o, s) {
    return o = t(o === void 0 ? n.length - 1 : o, 0), function() {
      for (var a = arguments, i = -1, u = t(a.length - o, 0), l = Array(u); ++i < u; )
        l[i] = a[o + i];
      i = -1;
      for (var c = Array(o + 1); ++i < o; )
        c[i] = a[i];
      return c[o] = s(l), e(n, this, c);
    };
  }
  return Mt = r, Mt;
}
var Lt, Un;
function gu() {
  if (Un) return Lt;
  Un = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Lt = e, Lt;
}
var Dt, En;
function hu() {
  if (En) return Dt;
  En = 1;
  var e = gu(), t = ca(), r = Ta(), n = t ? function(o, s) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(s),
      writable: !0
    });
  } : r;
  return Dt = n, Dt;
}
var Nt, Gn;
function mu() {
  if (Gn) return Nt;
  Gn = 1;
  var e = 800, t = 16, r = Date.now;
  function n(o) {
    var s = 0, a = 0;
    return function() {
      var i = r(), u = t - (i - a);
      if (a = i, u > 0) {
        if (++s >= e)
          return arguments[0];
      } else
        s = 0;
      return o.apply(void 0, arguments);
    };
  }
  return Nt = n, Nt;
}
var Ft, Hn;
function vu() {
  if (Hn) return Ft;
  Hn = 1;
  var e = hu(), t = mu(), r = t(e);
  return Ft = r, Ft;
}
var Ut, $n;
function yu() {
  if ($n) return Ut;
  $n = 1;
  var e = Ta(), t = pu(), r = vu();
  function n(o, s) {
    return r(t(o, s, e), o + "");
  }
  return Ut = n, Ut;
}
var Et, zn;
function _u() {
  if (zn) return Et;
  zn = 1;
  var e = Y(), t = Zt(), r = ba(), n = L();
  function o(s, a, i) {
    if (!n(i))
      return !1;
    var u = typeof a;
    return (u == "number" ? t(i) && r(a, i.length) : u == "string" && a in i) ? e(i[a], s) : !1;
  }
  return Et = o, Et;
}
var Gt, Kn;
function bu() {
  if (Kn) return Gt;
  Kn = 1;
  var e = yu(), t = _u();
  function r(n) {
    return e(function(o, s) {
      var a = -1, i = s.length, u = i > 1 ? s[i - 1] : void 0, l = i > 2 ? s[2] : void 0;
      for (u = n.length > 3 && typeof u == "function" ? (i--, u) : void 0, l && t(s[0], s[1], l) && (u = i < 3 ? void 0 : u, i = 1), o = Object(o); ++a < i; ) {
        var c = s[a];
        c && n(o, c, a, u);
      }
      return o;
    });
  }
  return Gt = r, Gt;
}
var Ht, Wn;
function wu() {
  if (Wn) return Ht;
  Wn = 1;
  var e = du(), t = bu(), r = t(function(n, o, s) {
    e(n, o, s);
  });
  return Ht = r, Ht;
}
var Tu = wu();
const Ca = /* @__PURE__ */ ui(Tu);
function Cu() {
  let e = window.screen.orientation.angle == 0 ? window.screen.height : window.screen.width;
  return navigator.userAgent.indexOf("Android") >= 0 && window.devicePixelRatio && (e = e / window.devicePixelRatio), e;
}
function Jn(e, t) {
  return {
    datalayer_version: e.version,
    site_envwork: e.site?.environment,
    site_family: e.site?.family,
    site_country: e.site?.country,
    site_business: e.site?.business,
    site_language: e.site?.language,
    site_target_group: null,
    site_responsivetype: Cu() >= 640 ? "Desktop" : "Mobile",
    page_version: e.page?.version,
    page_name: e.page?.name,
    page_id: e.page?.id,
    page_path: e.page?.path,
    page_type: e.page?.type,
    page_title: t,
    page_article_id: e.page?.articleId,
    page_publication_date: e.page?.publicationDate,
    page_website_goal: e.page?.websiteGoal,
    page_category: e.page?.categories,
    tags: e.page?.tags,
    user_type: e.user?.type,
    user_logged_id: e.user?.id,
    ...e.page?.customAttributes ?? {}
  };
}
const qa = (e, t) => {
  if (!window)
    return null;
  t ??= document.title, window.utag_data = {
    page_name: e.page?.name
    // Required because uxcl uses this to overwrite event sources
  };
  const r = Jn(e, t);
  return window.reinitTracking = (o) => {
    setTimeout(() => n(Ca(r, Jn(o, t))), 500);
  }, (o) => {
    r.user_type = o.userType, r.user_logged_id = o.userId, n(r);
  };
  function n(o) {
    if (window.utag_data = o, window.utag) {
      window.utag.view(o);
      return;
    }
    const s = document.createElement("script");
    s.text = `
window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
window.utag_cfg_ovrd.noview = true;`;
    const a = document.createElement("script");
    a.setAttribute("defer", ""), a.src = e.utagScriptUrl, a.addEventListener("load", () => {
      if (window.utag?.view == null) {
        console.error("utag object or utag.view function not defined on window object.");
        return;
      }
      window.utag.view(o);
    }), window.document.head.appendChild(s), window.document.head.appendChild(a);
  }
};
async function Sa(e, t, r, n) {
  const a = await (await fetch(t, {
    method: "POST",
    body: JSON.stringify({ currentPageId: e }),
    headers: {
      "Content-Type": "application/json",
      "epi-current-page-id": e.toString()
    }
  })).json();
  a && (a.login && r(a.login), a.tracking && n(a.tracking));
}
const qu = /* @__PURE__ */ _({
  __name: "pageframe",
  props: {
    model: {},
    hideBreadcrumb: { type: Boolean },
    pageName: {}
  },
  setup(e) {
    const t = e, r = k(() => t.hideBreadcrumb || t.model.hideBreadcrumb), n = window != null;
    let o;
    n && t.model.tracking && (o = qa(t.model.tracking, t.model.seo?.websiteName));
    const s = C({ ...t.model, hideBreadcrumb: r.value }), a = sa(t.model.searchUrl, (i) => {
      s.value?.header?.iconList?.searchIcon && i && (s.value.header.iconList.searchIcon.result = i);
    });
    return s.value?.header?.iconList?.searchIcon && a.setStaticResult(t.model.header?.iconList?.searchIcon?.result), $t(async () => {
      n && await Sa(
        t.model.currentPageId,
        t.model.userDependentDataUrl,
        (i) => {
          s.value?.header?.iconList && (s.value.header.iconList.loginIcon = i);
        },
        (i) => {
          o && o({
            userType: i.type,
            userId: i.id
          });
        }
      );
    }), (i, u) => (g(), m(f(qo), {
      model: s.value,
      "page-name": t.pageName,
      onAudienceChanged: f(Kt),
      onSearch: f(a).search,
      onSearchClear: f(a).searchClear,
      onSearchShowChanged: f(a).searchClear
    }, {
      default: O(() => [
        e.model.leavingDisclaimer ? (g(), m(f(aa), ja({ key: 0 }, e.model.leavingDisclaimer, {
          "page-name": t.pageName
        }), null, 16, ["page-name"])) : x("", !0),
        j(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["model", "page-name", "onAudienceChanged", "onSearch", "onSearchClear", "onSearchShowChanged"]));
  }
}), Su = /* @__PURE__ */ _({
  __name: "pageframe-patternlab-header",
  props: {
    model: {
      type: Object,
      required: !1,
      default: null
    },
    searchUrl: {
      type: String,
      required: !1,
      default: null
    },
    tracking: {
      type: Object,
      required: !1,
      default: null
    },
    websiteName: {
      type: String,
      required: !1,
      default: null
    },
    userDependentDataUrl: {
      type: String,
      required: !0
    },
    currentPageId: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const t = e, r = C(t.model), n = sa(t.searchUrl, (s) => {
      r.value?.iconList?.searchIcon && s && (r.value.iconList.searchIcon.result = s);
    });
    let o;
    return t.tracking && (o = qa(t.tracking, t.websiteName ?? document.title)), $t(async () => {
      await Sa(
        t.currentPageId,
        t.userDependentDataUrl,
        (s) => {
          r.value?.iconList && (r.value.iconList.loginIcon = s);
        },
        (s) => {
          o && o({
            userType: s.type,
            userId: s.id
          });
        }
      );
    }), (s, a) => t.model ? (g(), m(f(So), {
      key: 0,
      model: r.value,
      onAudienceChanged: f(Kt),
      onSearch: f(n).search,
      onSearchClear: f(n).searchClear
    }, null, 8, ["model", "onAudienceChanged", "onSearch", "onSearchClear"])) : x("", !0);
  }
}), Pu = {
  en: {
    dwsCustomCarousel: {
      navBackward: "navigate backward",
      navForward: "navigate forward",
      navToPage: "navigate to page"
    }
  },
  de: {
    dwsCustomCarousel: {
      navBackward: "zurück blättern",
      navForward: "vorwärts blättern",
      navToPage: "navigiere zu Seite"
    }
  },
  es: {
    Accept: "Acepte",
    Cancel: "Cancelar"
  },
  fr: {
    Accept: "J'accepte",
    Cancel: "Annuler"
  },
  it: {
    Accept: "D'accordo",
    Cancel: "Cancella"
  },
  ja: {
    Accept: "はい",
    Cancel: "キャンセル"
  },
  nl: {
    Accept: "Aanvaarden",
    Cancel: "Annuleren"
  },
  pl: {
    Accept: "Przyjąć",
    Cancel: "Anulować"
  },
  pt: {
    Accept: "Aceitar",
    Cancel: "Cancelar"
  },
  sv: {
    Accept: "acceptera",
    Cancel: "Avsluta"
  },
  zh: {
    Accept: "同意",
    Cancel: "取消"
  }
}, Ru = [
  {
    locale: "en",
    emptyMessage: "No results found",
    emptyFilterMessage: "No results found"
  },
  {
    locale: "de",
    emptyMessage: "Keine Ergebnisse gefunden",
    emptyFilterMessage: "Keine Ergebnisse gefunden"
  },
  {
    locale: "es",
    emptyMessage: "No hay resultados",
    emptyFilterMessage: "No hay resultados"
  },
  {
    locale: "fr",
    emptyMessage: "Aucun résultat trouvé",
    emptyFilterMessage: "Aucun résultat trouvé"
  },
  {
    locale: "it",
    emptyMessage: "Nessun risultato trovato",
    emptyFilterMessage: "Nessun risultato trovato"
  },
  {
    locale: "pl",
    emptyMessage: "Nie znaleziono wyników",
    emptyFilterMessage: "Nie znaleziono wyników"
  },
  {
    locale: "pt",
    emptyMessage: "Nenhum resultado encontrado",
    emptyFilterMessage: "Nenhum resultado encontrado"
  },
  {
    locale: "zh",
    emptyMessage: "未找到结果",
    emptyFilterMessage: "未找到结果"
  },
  {
    locale: "nl",
    emptyMessage: "Geen resultaten gevonden",
    emptyFilterMessage: "Geen resultaten gevonden"
  },
  {
    locale: "sv",
    emptyMessage: "Inga resultat funna",
    emptyFilterMessage: "Inga resultat funna"
  }
], Ou = {
  baseImagePath: "/Resources/vue/",
  htmlContentBlockWhitelist: {
    ADD_TAGS: [],
    ADD_ATTR: []
  },
  translationOptions: {
    locale: "en",
    fallbackLocale: "en",
    messages: Pu
  },
  serviceUrlOptions: {
    isinValidationServiceUrl: "/EntryGate/other-country-validate-isin"
  },
  localesPrimeVue: Ru
};
function Qn(e) {
  return e.replace(/([a-z0–9])([A-Z])/g, "$1-$2").toLowerCase();
}
function Au(e, t, r, n, o) {
  const s = r;
  n.push(t), n.push(Qn(t)), s.props && o.push(
    ...Object.keys(s.props).map((a) => Qn(a)).map((a) => [a, ":" + a]).reduce((a, i) => a.concat(i), [])
  ), e.component(t, r);
}
function Iu(e, t, r) {
  const n = Ca(Ou, t), o = [], s = [], a = (i, u) => {
    Au(e, i, u, o, s);
  };
  return a("VueTeaserWorldwideWebsites", Po), a("VueTeaserHero", Ro), a("VueTeaserEvent", Oo), a("VueTeaserBoxes", Ao), a("VueKeyFacts", Io), a("VueProductsTeaserArea", Ms), a("VueTeaserTopProducts", jo), a("VueTeaserMostClickedProducts", ko), a("VueTeaserProductInFocus", xo), a("VuePersonSection", Bo), a("VuePersonDetailPage", Vo), a("VueTabContainer", Mo), a("VueTabContent", Lo), a("VueVideoModule", Do), a("VueDownloadList", No), a("VueTopicTileContentBlock", Fo), a("VueQuote", Uo), a("VueEntryGateModal", Os), a("VueAccordionContainer", Eo), a("VueAccordionItem", Go), a("VueSpace", Ds), a("VueHtml", Ps), a("VueHeader", Rs), a("FundSearch", ea), a("VueFundSearch", ws), a("VueLayout", Bs), a("VueLayoutRow", Vs), a("VueExpandableTeasers", Ho), a("VueEvervizCharts", $o), a("VueRiskDisclaimer", Ls), a("VueNewsletterTeaser", zo), a("VuePageFootnoteList", Ko), a("VuePageFootnoteReference", Wo), a("VueLeavingDisclaimer", aa), a("VueTeaserAnnouncements", qs), a("VueImage", Is), a("VueBaseDisclaimer", nr), a("VueTimeline", Jo), a("VueProductChartTeaser", Qo), a("VueProductChartTeasers", Zo), a("VueSearchResultsPage", Qs), a("VueArchivePage", zs), a("VuePropertyGalleryPage", Zs), a("VueDataTable", Xo), a("VueSingleVideoPlayer", Yo), a("VueErrorPage", es), a("VuePropertyDetailPage", Ys), a("VueFeaturedPropertyTeaser", ts), a("VueFactsList", rs), a("VueCalendarPage", Ks), a("VueFaqPage", Ws), a("VueGlossaryPage", ei), a("VueMarketDataBlock", ns), a("VueImageGallery", as), a("VueJumpmarkAnchor", os), a("VueArticleHeader", ss), a("VuePageOverview", Fs), a("VueImageBlock", Ss), a("VueContentBox", Ns), a("VueImageGalleryTeaser", is), a("VueMediaReleasesPage", ti), a("VueProductTeaserWithImage", us), a("VueQuiz", Gs), a("VuePoll", Es), a("VueDisclaimer", nr), a("VueContactBox", ls), a("VueMediaReleasesDetailsPage", cs), a("VueGlossaryItem", ds), a("VueContentSlider", Us), a("VueProductBuyingProcessPage", ri), a("VueEntryPopupDisclaimer", fs), a("VueAudioModule", ps), a("VueArticlePageLayout", gs), a("VueInvestmentCalculator", hs), a("VueInflationCalculator", ms), a("VueFormBuilder", vs), a("VueLoginPage", si), a("VueIFrame", ys), a("VuePageSection", zt), r && r(a), o.push("PageFootnoteReference"), n.htmlContentBlockWhitelist && (n.htmlContentBlockWhitelist.ADD_TAGS = o.filter((i, u, l) => l.indexOf(i) === u), n.htmlContentBlockWhitelist.ADD_ATTR = s.filter((i, u, l) => l.indexOf(i) === u)), n;
}
function xu(e) {
  const t = document.getElementsByClassName("vue"), r = Array.prototype.slice.call(t) || [], n = window.DACL?.config, o = n?.culture ?? "en", s = n?.fallbackCulture ?? "en";
  r.forEach((a) => {
    const u = ka({}), l = Iu(
      u,
      {
        translationOptions: {
          locale: o,
          fallbackLocale: s
        }
      },
      () => {
      }
    );
    u.component("VuePageFrame", qu), u.component("VuePageFramePatternlabHeader", Su), u.component("VuePageFramePatternlabFooter", ii), u.component("UxclBreadcrumb", _s), u.use(bs, l), e && e(u), u.mount(a);
  });
}
export {
  zs as ArchivePage,
  Ks as CalendarPage,
  Ns as ContentBox,
  Us as ContentSlider,
  qu as DaclPageFrame,
  Os as EntryGateModalComponent,
  Ws as FaqPage,
  ws as FundSearchComponent,
  ei as GlossaryPage,
  Rs as HeaderComponent,
  Ps as HtmlComponent,
  Ss as ImageBlock,
  Is as ImageComponent,
  Bs as LayoutComponent,
  Vs as LayoutRowComponent,
  aa as LeavingDisclaimerComponent,
  si as LoginPage,
  ti as MediaReleasesPage,
  Fs as PageOverview,
  Es as Poll,
  ri as ProductBuyingProcessPage,
  Xs as ProductIdentifierType,
  Ms as ProductsTeaserAreaComponent,
  Ys as PropertyDetailPage,
  Zs as PropertyGalleryPage,
  Gs as Quiz,
  Ls as RiskDisclaimerComponent,
  Qs as SearchResultsPage,
  Ds as SpaceComponent,
  qs as TeaserAnnouncementsComponent,
  Kt as audienceChanged,
  Iu as createDxPluginOptions,
  xu as initStaticVueApp,
  Pu as locales,
  Ru as localesPrimeVue,
  $ as useApiRequest,
  sa as usePageFrameSearchEvents,
  Sa as usePageFrameUserDataLoader,
  qa as useTealiumTracking,
  X as useUrlState
};
//# sourceMappingURL=dacl.cms.vue.components.js.map
